import { render, staticRenderFns } from "./InquiryListIframe.vue?vue&type=template&id=3f34f3ab&"
import script from "./InquiryListIframe.vue?vue&type=script&lang=ts&"
export * from "./InquiryListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports